export default __webpack_public_path__ + "static/media/logo_blue.16014236.svg";